import errorsMap from './map';

const errorMapping = status => errorsMap[status] || 'error.sb.default_error';

export default errorMapping;
